<template>
  <div>
    <slot name="label">
      <label v-if="label" class="" :class="labelClasses">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
    </slot>

    <v-select
      v-bind="$attrs"
      :class="inputClasses"
      :value="value"
      @input="selected"
      @change="changed"
      :rules="rules"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :disabled="disabled"
    >
    </v-select>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'BaseSelect',
  props: {
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)',
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: undefined,
    },
    label: {
      type: String,
      description: 'Input label (text before input)',
    },
    name: {
      type: String,
      description: 'Input name ',
    },
    text: {
      type: String,
      description: 'label text ',
    },
    helpText: {
      type: String,
      description: 'Input help text (text after input)',
    },

    labelClasses: {
      type: String,
      description: 'Input label css classes',
    },
    inputClasses: {
      type: String,
      description: 'Input css classes',
    },
    value: {
      description: 'Input value',
    },

    icon: {
      type: String,
      description: ' left icon',
    },
    errors: {
      default: null,
    },
    items: {
      default: [],
    },
    rules: Array,
    itemText: {
      type: String,
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'key',
    },
    disabled: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      focused: false,
    };
  },

  methods: {
    fetchOptions(search, loading) {
      this.$emit('search', search);
    },
    selected(value) {
      this.$emit('input', value);
    },
    changed(value) {
      this.$emit('change', value);
    },
  },
};
</script>
<style lang="scss">
.vs__dropdown-menu {
  text-align: right !important;
}
.vs__clear {
  margin-left: 8px;
}
.vue-select__custom .vs__search::placeholder,
.vue-select__custom .vs__dropdown-toggle,
.vue-select__custom .vs__dropdown-menu {
  padding: 5px 0 7px !important;
  direction: rtl !important;
  & .vs__search,
  .vs__search:focus {
    margin-top: 8px !important;
  }
}

.is-invalid .vs__search::placeholder,
.is-invalid .vs__dropdown-toggle,
.is-invalid .vs__dropdown-menu {
  border: 1px solid red;
}

.is-invalid .vs__clear,
.is-invalid .vs__open-indicator {
  fill: #bababb;
}
</style>
